@switch (data?.status) {
    @case (importStatusEnum.SUCCESSFUL) {
        <div class="status-display successful">
            <i class="fas true fa-check"></i>
        </div>
    }
    @case (importStatusEnum.FAILED) {
        <div class="status-display failed">
            <i class="fas false fa-xmark"></i>
        </div>
    }
    @case (importStatusEnum.PARTIALLY_SUCCESSFUL) {
        @if ((data?.itemDetails ?? []).length > 0) {
            <div
                appTooltip
                trigger="hover"
                [component]="tooltipComponent"
                [componentData]="data"
                position="bottom"
                [showDelay]="200"
                [hideDelay]="200"
            >
                <ng-container *ngTemplateOutlet="partialSuccessIcon"></ng-container>
            </div>
        } @else {
            <ng-container *ngTemplateOutlet="partialSuccessIcon"></ng-container>
        }
    }
}

<ng-template #partialSuccessIcon>
    <div class="status-display partial">
        <i class="fas fa-diamond-half-stroke"></i>
    </div>
</ng-template>
